export default __webpack_public_path__ + "static/198-ccb0ada9fd9af4684abd21a1a2191b5f.jpg";